import DeleteClient from "@/v2/api/client/Delete";
import DeleteButton from "../general/Delete";

export default function ClientDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["clients"]}
            deleteFn={DeleteClient}
            title="Delete Client"
            description="Are you sure you want to delete this client record? This action cannot be undone. Click delete to confirm."
            successTitle="Client Deleted Successfully"
            isInside={isInside}
        />
    );
}
